//function to add focus styles only after tab key is pressed

export function tabKey() {
  function handleFirstTab(e) {
      if (e.key === 'Tab') {
          document.body.classList.add('tab-key-active');
          window.removeEventListener('keydown', handleFirstTab);
      }
  }

  function removeTabKeyClass() {
      document.body.classList.remove('tab-key-active');
      window.addEventListener('keydown', handleFirstTab);
  }

  window.addEventListener('keydown', handleFirstTab);
  window.addEventListener('mousedown', removeTabKeyClass);
  window.addEventListener('touchstart', removeTabKeyClass);
}
